export const SUBHEAD_EID = 'subhead';
export const SUBTIT_EID = 'subtit';
export const TIT_EID = 'tit';
